CONFIGURATOR_VARIANTS.forEach((element, index) => {
  const NUMBER_OF_QUESTIONS = CONFIGURATOR_DATA.steps.length;
  const NUMBER_OF_VARIANT_TYPES = CONFIGURATOR_VARIANTS.length;
  const WRITING_INDEX = index + NUMBER_OF_QUESTIONS - NUMBER_OF_VARIANT_TYPES;

  element.optionValues.forEach((innerElement, innerIndex) => {
    CONFIGURATOR_DATA.steps[WRITING_INDEX].options[innerIndex].title =
      innerElement.value;
  });
});

let numberReady = false;
let replenInfo;
let productInfo;

function cleanEmptyFields(data) {
  let cleanSteps = [];

  data.forEach((element) => {
    let cleanOptions = [];
    let cleanOption;
    let cleanElement;

    element.options.forEach((option) => {
      let cleanCarousel = [];

      option.carousel.forEach((carouselItem) => {
        if (!carouselItem.includes("error")) {
          cleanCarousel.push(carouselItem);
        }
      });

      if (!cleanCarousel.length) {
        cleanOption = removeEmptyElements(option);
        delete cleanOption.carousel;
      } else {
        cleanOption = {
          ...removeEmptyElements(option),
          carousel: cleanCarousel,
        };
      }

      cleanOptions.push(cleanOption);
    });

    cleanElement = removeEmptyElements(element);
    cleanSteps.push({ ...cleanElement, options: cleanOptions });
  });
  return cleanSteps;
}

const exitElement = document.querySelector(".configurator-header-close");

if (exitElement) {
  exitElement.addEventListener("click", () => history.back());
}

//Append drag-to-choose component
const dragToChoose = document.getElementsByClassName("input-range__wrapper")[0];
const elementToAppendTo = document.getElementsByClassName(
  "configurator-mobile-drag"
)[0];
elementToAppendTo.append(dragToChoose);

//Append Accessories page
const accessoriesPage = document.getElementById("accessories-page");

const headerElementWrapper =
  document.getElementsByClassName("header-wrapper")[0];
const accessoriesHeaderElementWrapper = document.getElementsByClassName(
  "accessories-header-wrapper"
)[0];
const footerElementWrapper = document.getElementsByClassName("footer")[0];
const footerPatternElement =
  document.getElementsByClassName("footer-pattern")[0];

if (accessoriesHeaderElementWrapper) {
  accessoriesPage.append(accessoriesHeaderElementWrapper);
}

// Now we are showing addon-carousel
const addOnCarousel = document.getElementsByClassName("add-on-carousel")[0];
if (addOnCarousel) {
  accessoriesPage.append(addOnCarousel);
} else {
  // This is old code, where we where showing accessories cards on the page after header
  const accessoriesCardElementWrapper =
    document.getElementsByClassName("accessories-card");

  if (accessoriesCardElementWrapper) {
    if (accessoriesCardElementWrapper.length > 1) {
      Array.from(accessoriesCardElementWrapper).forEach((element) => {
        accessoriesPage.append(element);
      });
    } else {
      accessoriesPage.append(accessoriesCardElementWrapper[0]);
    }
  }
}

if (footerElementWrapper) {
  accessoriesPage.append(footerElementWrapper);
}

if (footerPatternElement) {
  accessoriesPage.append(footerPatternElement);
}
// Append configurator-heading
const configuratorHeadingElementWrapper = document.getElementsByClassName(
  "configurator-header-section"
)[0];
const configuratorElementWrapper =
  document.getElementsByClassName("configurator")[0];

configuratorElementWrapper.insertBefore(
  configuratorHeadingElementWrapper,
  configuratorElementWrapper.firstChild
);

////----////

const CLEAN_STEPS = cleanEmptyFields(CONFIGURATOR_DATA.steps);

const FINAL_CONFIGURATOR_DATA = { ...CONFIGURATOR_DATA, steps: CLEAN_STEPS };
const BREAKPOINT_VARIANTS = {
  DESKTOP: "DESKTOP",
  MOBILE: "MOBILE",
};

const numberReadyCallback = () => {
  if (breakpointVariant === BREAKPOINT_VARIANTS.DESKTOP) {
    renderDesktopVisual(currentVisualIndex);

    if (window.location.search === "?quiz") {
      setTimeout(() => {
        openQuiz();
        clearInterval(numbersSwitchInterval);
      }, 100);
    }
  } else {
    if (window.location.search === "?quiz") {
      const getHelpDecidingButton = document.querySelector(
        ".get-help-button-wrapper"
      );
      if (getHelpDecidingButton && !numberReady) {
        getHelpDecidingButton.click();
      }
    }
  }
  numberReady = true;
};

const debounce = (callback, wait) => {
  let timeoutId = null;
  return (...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      callback.apply(null, args);
    }, wait);
  };
};

const handleScroll = () => {
  let previous;
  const scrollPos = window.scrollY;
  const math = scrollPos + SCROLL_OFFSET;

  handleNextSectionButtonBehavior();

  if (breakpointVariant === BREAKPOINT_VARIANTS.DESKTOP && offsetTops.length) {
    const closestPosition = offsetTops.reduce(function (prev, curr) {
      return Math.abs(curr - math) < Math.abs(prev - math) ? curr : prev;
    });
    const selectedStepIndex = offsetTops.findIndex(
      (i) => i === closestPosition
    );
    // If step is completed or is next to be
    const stepsPopulated = Object.values(configuratorData).length;

    if (
      previous !== currentVisualIndex &&
      selectedStepIndex !== currentVisualIndex &&
      stepsPopulated >= selectedStepIndex
    ) {
      currentVisualIndex = selectedStepIndex;
      visual.classList.add("visual-fadeout");
      renderDesktopVisual(selectedStepIndex, selectedStepIndex === 0);
      setTimeout(() => {
        if (selectedStepIndex === 0) {
          visualNumbers.classList.remove("visual-fadeout");
        }
        visual.classList.remove("visual-fadeout");
      }, 500);
    }
    previous = currentVisualIndex;
  }
};

const throttledScrollListener = debounce(handleScroll, 100);

let breakpointVariant;
let previousDragToChooseValue;

const setBreakpointVariant = (windowWidth) => {
  breakpointVariant =
    windowWidth < 900
      ? BREAKPOINT_VARIANTS.MOBILE
      : BREAKPOINT_VARIANTS.DESKTOP;
  window.addEventListener("scroll", throttledScrollListener);
};

setBreakpointVariant(window.innerWidth);

let currentVisualIndex = 0; // index of content shown on the right site
const animatedNumber = new AnimatedNumber(
  ANIMATED_NUMBERS_COLORS_MAP,
  numberReadyCallback
);

const monthlyPlans = Object.keys(ANIMATED_NUMBERS_COLORS_MAP)
  .map((element, index) => {
    if (index !== 0) {
      return parseInt(element);
    }
  })
  .filter(function (element) {
    return element !== undefined;
  });

function checkStringForNumbers(input) {
  let str = String(input);
  let number;
  for (let i = 0; i < str.length; i++) {
    let numberCheck = parseInt(str.charAt(i));
    if (!isNaN(numberCheck)) {
      number = str.charAt(i);
    }
  }
  return parseInt(number);
}

const lowPlan = monthlyPlans[0];
const midPlan = monthlyPlans[1];
const highPlan = monthlyPlans[2];

let configuratorDisabled = false;
let accordion;
let numbersSwitchInterval; // interval for rotating between numbers from monthlyPlans
const offsetTops = []; // each step's offsetTop
let configuratorData = {}; // data for form
let recommendedChoice = "";
let defaultRecommendationChoice = `${midPlan} months`;
let defaultRecommendationChoiceMessage = `Most people Replen every ${midPlan} months`;
let computedChoiceMessage = "";
let quizState;
let reasonState;
let planStrength;
const UNSELECTED_NUMBER_INTERVAL_TIMER = 2000;
const PADDING_OFFSET = 80;
const SCROLL_OFFSET = 96;
let galleries = [];
let nextUncompletedSection;
let shouldOpenQuiz = false;
let savePlan = "";
// elements
const configurator = document.querySelector(".configurator");
const selection = document.querySelector(".configurator-selection");
const visual = document.querySelector(".configurator-visual");
const visualNumbers = document.querySelector(".configurator-number-wrapper");
const visualGallery = document.querySelector(".configurator-gallery-wrapper");
//variants (both matching by index)
const variantOptionsArray = [];
const variantTypesArray = [];

const toggleControlsDisabledState = () => {
  const addToBagButton = document.querySelector(".configurator-add");

  const shouldEnableControls =
    configuratorData[1] == "confirmed" &&
    Object.keys(configuratorData).length === CONFIGURATOR_DATA.steps.length;

  if (shouldEnableControls) {
    addToBagButton.removeAttribute("disabled");
    addToBagButton.removeAttribute("data-disabled");
  } else {
    addToBagButton.setAttribute("disabled", true);
    addToBagButton.setAttribute("data-disabled", true);
  }
};

const updateHeaderPrice = () => {
  setTimeout(() => {
    const headerPriceElement = document.getElementsByClassName(
      "configurator-header-price"
    )[0];
    const headerReplenPriceElement = document.getElementsByClassName(
      "configurator-header-replen-price"
    )[0];
    const table = document.getElementsByClassName(
      "configurator-table-items"
    )[0];
    const tableItems = Array.from(
      table.getElementsByClassName("configurator-table-item")
    );
    if (tableItems[tableItems.length - 1]) {
      const priceItem =
        tableItems[tableItems.length - 1].childNodes[
          tableItems[tableItems.length - 1].childNodes.length - 1
        ];
      let replenPriceText = `${priceItem.textContent} on next delivery`;
      let priceText;
      if (configuratorProductPrice) {
        priceText = `${configuratorProductPrice} today`;
      }

      if (configuratorData["0"] == "No plan") {
        replenPriceText = "";
        priceText = configuratorProductPrice;
      }

      headerPriceElement.innerHTML = priceText || "";
      headerReplenPriceElement.getElementsByClassName(
        "configurator-header-price"
      )[0].innerHTML = replenPriceText || "";
    }
  }, 100);
};

const drawNumbersByMonthlyPlans = () => {
  var currentNumberIndex = 1;
  numbersSwitchInterval = setInterval(() => {
    ++currentNumberIndex;
    if (currentNumberIndex >= monthlyPlans.length) {
      currentNumberIndex = 0;
    }
    animatedNumber.animate(monthlyPlans[currentNumberIndex]);
  }, UNSELECTED_NUMBER_INTERVAL_TIMER);
};

const renderMobileBottomBar = () => {
  const previousWrapperHolder = document.getElementsByClassName(
    "bottom-recommendation-wrapper-holder"
  )[0];
  const previousWrapper = document.getElementsByClassName(
    "bottom-recommendation-wrapper"
  )[0];

  let mobileRecommendationWrapperHolder;

  if (previousWrapperHolder) {
    mobileRecommendationWrapperHolder = previousWrapperHolder;
    previousWrapper && previousWrapper.classList.add("goUp");
  } else {
    mobileRecommendationWrapperHolder = document.createElement("div");
    mobileRecommendationWrapperHolder.classList.add(
      "bottom-recommendation-wrapper-holder"
    );
  }

  //Create loader
  const loader = document.querySelector(".three-dots-lottie");
  const loaderCopy = loader.cloneNode();

  setTimeout(() => {
    const lottieContainer = document.querySelector(".three-dots-lottie");

    lottie.loadAnimation({
      container: lottieContainer,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: "https://cdn.shopify.com/s/files/1/0648/9384/5739/files/three-dots-lottie.json?v=1659728191",
      name: "loader",
    });
  }, 200);

  mobileRecommendationWrapperHolder.appendChild(loaderCopy);

  setTimeout(
    () => {
      mobileRecommendationWrapperHolder.innerHTML = "";
      const mobileRecommendationWrapper = document.createElement("div");
      mobileRecommendationWrapper.classList.add(
        "bottom-recommendation-wrapper",
        `${!!previousWrapperHolder ? "goDown" : "goUp"}`
      );

      //Create image // TODO CREATE A NUMBER.js here
      const recommendationNumberImage = document.createElement("div");
      recommendationNumberImage.classList.add("bottom-recommendation-number");

      const bottomBarNumber = new AnimatedNumber(
        ANIMATED_NUMBERS_COLORS_MAP,
        numberReadyCallback
      );
      recommendationNumberImage.appendChild(bottomBarNumber.init(midPlan));
      bottomBarNumber.animate(
        recommendedChoice ? parseInt(recommendedChoice.charAt(0)) : midPlan
      );

      //Create text
      const textElement = document.createElement("p");
      textElement.classList.add(
        "typography",
        "caption",
        "bottom-recommendation-text"
      );
      textElement.innerHTML = `Most people should Replen every ${midPlan} months`;

      //Create button
      const selectButton = document.createElement("button");
      selectButton.classList.add("bottom-recommendation-select-button");
      const selectButtonText = document.createElement("p");
      selectButtonText.classList.add("typography", "body-large-emphasize");
      selectButtonText.innerHTML = "Select";
      selectButton.appendChild(selectButtonText);

      //Stack elements in order and append to root;
      mobileRecommendationWrapper.appendChild(recommendationNumberImage);
      mobileRecommendationWrapper.appendChild(textElement);

      //If recommendedChoice is set, we need a bit different rules;
      if (recommendedChoice !== "") {
        mobileRecommendationWrapper.appendChild(selectButton);
        selectButton.classList.add(`message-${planStrength}-months`);
        textElement.innerHTML = `${
          CONFIGURATOR_DATA.recommendationSentence ||
          "Based on your answers, you should Replen every"
        } ${recommendedChoice}`;
        mobileRecommendationWrapper.style.justifyContent = "space-between";
        selectButton.addEventListener("click", () => {
          const select = document.getElementsByClassName(
            "selectPlanMessageButton"
          )[0];
          select.click();
        });
      }

      mobileRecommendationWrapperHolder.appendChild(
        mobileRecommendationWrapper
      );

      const rootElement = document.getElementsByClassName("configurator")[0];
      rootElement.appendChild(mobileRecommendationWrapperHolder);

      //reveal
      setTimeout(() => {
        mobileRecommendationWrapper.classList.remove("goDown", "goUp");
      }, 300);
    },
    !!previousWrapperHolder ? 1800 : 100
  );
};

const handleNextSectionButtonBehavior = () => {
  const isQuizVisible = document.querySelector(".quiz--visible");
  if (!isQuizVisible) {
    const button = document.querySelector(".configurator-control-button");
    const allSections = Array.from(
      document.querySelectorAll(".configurator-step")
    );
    allSections.push(document.querySelector(".configurator-controls"));
    const numberOfCompletedSections = Object.keys(configuratorData).length;
    const firstUncompletedSection = allSections[numberOfCompletedSections];

    if (firstUncompletedSection) {
      const sectionOffsetTop =
        firstUncompletedSection.getBoundingClientRect().top;
      if (sectionOffsetTop <= window.innerHeight - PADDING_OFFSET) {
        nextUncompletedSection = null;
        button.classList.remove("configurator-control-button--visible");
      } else {
        nextUncompletedSection = firstUncompletedSection;
        button.classList.add("configurator-control-button--visible");
      }
    }
  }
};

const handleClick = (event, option, stepIndex, toQuiz = false) => {
  if (!configuratorDisabled) {
    if (option.snippet === "button") {
      shouldOpenQuiz = true;
    }

    if (stepIndex === 0) {
      finalChoiceForAccessoriesPage = option.title;
    }
    //Write variant options
    if (stepIndex != 0 && stepIndex != 1) {
      const index = stepIndex === 2 ? 0 : 1;

      variantTypesArray[index] =
        event.currentTarget.getAttribute("variant-type");
      variantOptionsArray[index] = option.title;
    }

    const isSameAnswer = configuratorData[stepIndex] === option.title;
    const currentStep = document.querySelector(
      `.configurator-step--${stepIndex}`
    );
    const nextStep = document.querySelector(
      `.configurator-step--${stepIndex + 1}`
    );
    clearInterval(numbersSwitchInterval);

    if (option.title != CONFIGURATOR_DATA.steps[0].options[3].title) {
      savePlan = option.title;
    }

    if (!isSameAnswer || toQuiz) {
      configuratorData = {
        ...configuratorData,
        [stepIndex]: option.title,
      };

      handleNextSectionButtonBehavior();

      const allButtonsInThisStep = Array.from(
        currentStep.querySelectorAll(".choice-button-wrapper")
      );

      allButtonsInThisStep.forEach((button) => {
        if (button.classList.contains("choice-button-wrapper--selected")) {
          button.classList.remove("choice-button-wrapper--selected");
        }
      });

      if (event && event.currentTarget) {
        event.currentTarget.classList.add("choice-button-wrapper--selected");
      } else {
        const currentStepButton = Array.from(
          currentStep.querySelectorAll(".choice-button-wrapper")
        ).find((n) => n.textContent.includes(`6 months`));
        currentStepButton.classList.add("choice-button-wrapper--selected");
      }
      if (option.snippet !== "button") {
        currentVisualIndex = stepIndex;
        if (
          nextStep &&
          !nextStep.classList.contains(".configurator-step--available")
        ) {
          nextStep.classList.add("configurator-step--available");
          const buttonChildren = Array.from(
            nextStep.getElementsByTagName("button")
          );
          buttonChildren.forEach((button) => {
            // We want to Stall button stays disabled
            const buttonTitleElement = button.querySelector("p:first-child");
            const isStallButton =
              buttonTitleElement && buttonTitleElement.textContent === "Stall";
            if (!isStallButton) {
              button.removeAttribute("disabled");
            }
          });
        }
      } else {
        nextStep.classList.remove("configurator-step--available");
      }

      if (breakpointVariant === BREAKPOINT_VARIANTS.DESKTOP) {
        renderDesktopVisual(stepIndex);
      } else {
        if (stepIndex !== 0) {
          const placeholderImage = currentStep.querySelector(
            ".configurator-image"
          );
          if (placeholderImage) {
            placeholderImage.remove();
          }

          const carouselData = FINAL_CONFIGURATOR_DATA.steps[
            stepIndex
          ].options.find(
            (option) => option.title === configuratorData[stepIndex]
          ).carousel;

          const carouselDataAltTexts = FINAL_CONFIGURATOR_DATA.steps[
            stepIndex
          ].options.find(
            (option) => option.title === configuratorData[stepIndex]
          ).carouselAltTexts;
          const visualElement = document.querySelector(
            `.configurator-step-visual--${stepIndex} .configurator-step-visual-content`
          );

          const galleryInstance = galleries[stepIndex - 1];
          const galleryElementInThisStep = visualElement.querySelector(
            `#gallery-${stepIndex}`
          );

          if (galleryElementInThisStep) {
            galleryElementInThisStep.remove();
          }

          setTimeout(() => {
            visualElement.appendChild(
              galleryInstance.init(carouselData, carouselDataAltTexts)
            );
          }, 100);
        }
      }
      if (stepIndex == 0) {
        configuratorData[1] = "";
      }
      toggleControlsDisabledState();

      const selectedCheckbox = document.querySelector(
        ".configurator-checkbox-message--visible"
      );
      if (stepIndex === 0) {
        // Update Second section content
        document.getElementById("configurator-checkbox").checked = false;
        handleTableSection(
          FINAL_CONFIGURATOR_DATA.steps[1].options,
          document.querySelector(".configurator-step--1")
        );

        if (selectedCheckbox) {
          selectedCheckbox.classList.remove(
            "configurator-checkbox-message--visible"
          );
        }
      }
    }
  }
};

const openQuiz = () => {
  shouldOpenQuiz = false;
  const header = document.getElementsByClassName("configurator-header")[0];
  const returnToConfigurator = () => {
    shouldOpenQuiz = false;
    const quizBottomBar = document.getElementsByClassName(
      "bottom-recommendation-wrapper-holder"
    )[0];
    quizBottomBar && quizBottomBar.remove();
    window.addEventListener("scroll", throttledScrollListener);
    document.querySelector("body").classList.remove("overflow-hidden");
    quizHeader.classList.remove("quiz-header--visible");
    quizContainer.classList.remove("quiz--visible");
    setTimeout(() => {
      visual.classList.remove("visual-quiz");
      selection.classList.remove("visual-fadeout");
      header.classList.remove("configurator-header--hidden");
      configuratorDisabled = false;
    }, 350);
  };
  // OPEN QUIZ
  header.classList.add("configurator-header--hidden");
  configuratorDisabled = true;

  const quizBottomBar = document.getElementsByClassName(
    "bottom-recommendation-wrapper-holder"
  )[0];
  quizBottomBar && quizBottomBar.remove();

  window.removeEventListener("scroll", throttledScrollListener);
  document
    .querySelector(".configurator-control-button")
    .classList.remove("configurator-control-button--visible");
  selection.classList.add("visual-fadeout");
  setTimeout(() => {
    visual.classList.add("visual-quiz");
  }, 350);

  const selectPickYourPlan = (value) => {
    const currentStep = document.querySelector(`.configurator-step--${0}`);

    const allButtonsInThisStep = Array.from(
      currentStep.querySelectorAll(".choice-button-wrapper")
    );

    const buttonBadge = document.createTextNode("For you");
    const optionBadge = document.createElement("div");
    optionBadge.classList.add("typography", "caption", "choice-button__badge");
    optionBadge.appendChild(buttonBadge);

    allButtonsInThisStep.forEach((element) => {
      element.classList.remove("choice-button-wrapper--selected");

      Array.from(element.children).forEach((child) => {
        if (child.classList.contains("choice-button__badge")) {
          child.remove();
        }
      });

      if (value.includes(element.textContent)) {
        element.append(optionBadge);

        configuratorData = {
          ...configuratorData,
          0: value,
        };
        handleNextSectionButtonBehavior();
        element.classList.add("choice-button-wrapper--selected");
        setTimeout(() => {
          element.click();
        }, 500);
      }
    });
  };

  //render plan message
  if (window.innerWidth < 900) {
    renderMobileBottomBar();
  }

  const hasRenderedPlanMessage = document.querySelector("#SelectPlanMessage");
  if (hasRenderedPlanMessage) hasRenderedPlanMessage.remove();
  const selectPlanMessage = document.createElement("div");

  selectPlanMessage.id = "SelectPlanMessage";
  selectPlanMessage.classList.add("selectPlanMessage");

  const selectPlanMessageText = document.createElement("p");
  selectPlanMessageText.classList.add(
    "typography",
    "body",
    "selectPlanMessageText"
  );

  selectPlanMessageText.innerHTML =
    computedChoiceMessage || defaultRecommendationChoiceMessage || "";

  const selectPlanMessageButton = document.createElement("button");
  selectPlanMessageButton.innerHTML = "Select";
  selectPlanMessageButton.classList.add(
    "selectPlanMessageButton",
    "body-large-emphasize"
  );

  // select recommended plan button handler
  const handleSelectPlanMessageButtonClick = () => {
    returnToConfigurator();
    handleClick(null, { title: recommendedChoice }, 0);
    selectPickYourPlan(recommendedChoice);
  };

  //This was inside "if(!recommendedChoice)" don't know why, for now it looks like its better to be here.
  selectPlanMessageButton.addEventListener(
    "click",
    handleSelectPlanMessageButtonClick
  );
  if (!recommendedChoice) {
    animatedNumber.animate(midPlan);
    selectPlanMessageButton.style.display = "none";
  } else {
    animatedNumber.animate(Number(recommendedChoice[0]));
    selectPlanMessageButton.style.display = "block";
    selectPlanMessageButton.classList.add(`message-${planStrength}-months`);
  }

  setTimeout(() => {
    selectPlanMessage.classList.add("message-fade-out");
  }, 800);

  setTimeout(() => {
    selectPlanMessage.classList.remove("message-fade-out");
    selectPlanMessage.innerHTML = "";
    selectPlanMessage.appendChild(selectPlanMessageText);
    selectPlanMessage.appendChild(selectPlanMessageButton);
  }, 1000);

  const accordionCallback = (data, quizData, reason) => {
    quizState = quizData;
    recommendedChoice = data;
    savePlan = data;
    reasonState = reason;

    finalChoiceForAccessoriesPage = recommendedChoice;

    switch (recommendedChoice) {
      case QUIZ_DATA.quizRules[0].ruleName:
        planStrength = "high";
        break;
      case QUIZ_DATA.quizRules[1].ruleName:
        planStrength = "mid";
        break;
      case QUIZ_DATA.quizRules[2].ruleName:
        planStrength = "low";
        break;
    }

    if (window.innerWidth < 900) {
      renderMobileBottomBar();
    }

    selectPlanMessage.classList.add("message-fade-out");

    const loader = document.getElementById("loader-wave-dots");
    visualNumbers.append(loader);

    setTimeout(() => {
      loader.style.opacity = 1;
    }, 200);

    setTimeout(() => {
      selectPlanMessage.innerHTML = "";
      loader.style.opacity = 0;
      selectPlanMessage.appendChild(selectPlanMessageText);

      selectPlanMessage.appendChild(selectPlanMessageButton);

      selectPlanMessage.classList.remove("message-fade-out");
      selectPlanMessage.classList.add("message-fade-in");

      const ruleTitleArray = [];

      QUIZ_DATA.quizRules.forEach((element) => {
        ruleTitleArray.push(element.ruleName);
      });
      //Find Rule, change numer, button and message.
      ruleTitleArray.forEach((rule) => {
        if (rule === data) {
          ruleTitleArray.forEach((title) => {
            selectPlanMessageButton.classList.remove(`message-high-months`);
            selectPlanMessageButton.classList.remove(`message-mid-months`);
            selectPlanMessageButton.classList.remove(`message-low-months`);
          });
          selectPlanMessageButton.classList.add(
            `message-${planStrength}-months`
          );
          animatedNumber.animate(parseInt(rule.charAt(0)));
        }
      });

      if (recommendedChoice !== "") {
        computedChoiceMessage = `${
          CONFIGURATOR_DATA.recommendationSentence ||
          "Based on your answers, you should Replen every"
        } ${recommendedChoice}`;
        selectPlanMessageText.innerHTML = computedChoiceMessage || "";
        selectPlanMessageButton.style.display = "block";

        handleOnInput(null, recommendedChoice);
      }
    }, 1200);

    setTimeout(() => {
      selectPlanMessage.classList.remove("message-fade-in");
    }, 1500);

    setTimeout(() => {
      const getSelectPlanMessageButton = document.getElementsByClassName(
        "selectPlanMessageButton"
      )[0];

      getSelectPlanMessageButton.removeEventListener(
        "click",
        handleSelectPlanMessageButtonClick
      );
      getSelectPlanMessageButton.addEventListener("click", () => {
        returnToConfigurator();
        selectPlanMessage.textContent = "";
        selectPickYourPlan(data);
      });
    }, 1600);
  };

  visualNumbers.appendChild(selectPlanMessage);

  document.querySelector("body").classList.add("overflow-hidden");

  const quizContainer = document.createElement("div");
  quizContainer.classList.add("quiz");

  accordion.renderSection(quizContainer, accordionCallback, reasonState);

  const getQuizHeader = document.getElementsByClassName("quiz-header")[0];
  if (getQuizHeader) {
    getQuizHeader.remove();
  }
  const quizHeader = document.createElement("div");
  quizHeader.classList.add("quiz-header");

  const back = document.createElement("button");
  back.setAttribute("aria-label", "Go back to configurator");
  back.classList.add("quiz-back");
  quizHeader.appendChild(back);
  configurator.appendChild(quizHeader);

  back.addEventListener("click", () => {
    returnToConfigurator();
    clearInterval(numbersSwitchInterval);

    let checkPrevious = savePlan || recommendedChoice;
    if (checkPrevious) {
      configuratorData = {
        ...configuratorData,
        0: checkPrevious,
      };

      const currentStep = document.querySelector(`.configurator-step--${0}`);

      const allButtonsInThisStep = Array.from(
        currentStep.querySelectorAll(".choice-button-wrapper")
      );
      setTimeout(() => {
        allButtonsInThisStep.forEach((element) => {
          if (
            checkStringForNumbers(checkPrevious) ==
            checkStringForNumbers(element.textContent)
          ) {
            element.classList.add("choice-button-wrapper--selected");
            setTimeout(() => {
              element.click();
            }, 500);
          }
        });
      }, 100);
    }
    if (configuratorData["0"]) {
      if (configuratorData["0"] == "Get help deciding") {
        if (recommendedChoice) {
          animatedNumber.animate(parseInt(recommendedChoice.charAt(0)));
        } else {
          drawNumbersByMonthlyPlans();
        }
      } else {
        let planNumber = parseInt(
          configuratorData["0"].replace("Every ", "").charAt(0)
        );
        if (!planNumber) {
          animatedNumber.animate(0);
        } else {
          animatedNumber.animate(planNumber);
        }
      }
    } else {
      drawNumbersByMonthlyPlans();
    }
  });

  configurator.appendChild(quizContainer);

  setTimeout(() => {
    quizHeader.classList.add("quiz-header--visible");
    quizContainer.classList.add("quiz--visible");
  }, 500);
};

const renderDesktopVisual = (selectedStep, delayNumbers, mobile = false) => {
  const activeStepData = FINAL_CONFIGURATOR_DATA.steps[selectedStep];
  const unselectedImage = document.querySelector(".configurator-image");
  if (activeStepData) {
    if (activeStepData.visual === "numbers") {
      visualGallery.classList.add("visual-fadeout");
      if (visualGallery.querySelector(".gallery-container")) {
        visualGallery
          .querySelector(".gallery-container")
          .classList.add("visual-fadeout");
      }

      if (!mobile && unselectedImage) {
        unselectedImage.classList.add("visual-fadeout");
      }

      const hasSelectedNumber = Object.values(configuratorData).length > 0;
      let num;
      if (hasSelectedNumber || mobile) {
        if (!mobile) {
          const numberInput = configuratorData[0];
          num = numberInput === "No plan" ? 0 : Number(numberInput[0]);
          if (delayNumbers) {
            setTimeout(() => {
              visualNumbers.classList.remove("visual-fadeout");
            }, 400);
          } else {
            visualNumbers.classList.remove("visual-fadeout");
          }
        }
        if (!isNaN(num) && !mobile) {
          animatedNumber.animate(num || Number(recommendedChoice.charAt(0)));
        } else {
          if (shouldOpenQuiz) {
            openQuiz();
          }
        }
      } else {
        let number = 3;
        visualNumbers.appendChild(animatedNumber.init(number));
        animatedNumber.animate(midPlan);
        if (!numbersSwitchInterval) {
          drawNumbersByMonthlyPlans();
        }
      }
    } else if (activeStepData.visual === "gallery") {
      visualNumbers.classList.add("visual-fadeout");
      const galleryInstance = galleries[selectedStep - 1];

      const galleryElementInThisStep = visualGallery.querySelector(
        `#gallery-${selectedStep}`
      );
      const allGalleries = Array.from(
        document.getElementsByClassName("gallery-container")
      );

      setTimeout(() => {
        visualGallery.classList.remove("visual-fadeout");
        const selectedAnswer = configuratorData[selectedStep];
        const isOnDeliveryStep = activeStepData.isStatic;
        if (selectedAnswer && !isOnDeliveryStep) {
          if (unselectedImage) {
            visualGallery.removeChild(unselectedImage);
          }

          const carouselData = activeStepData.options.find(
            (option) => option.title === selectedAnswer
          ).carousel;
          const carouselAltTexts = activeStepData.options.find(
            (option) => option.title === selectedAnswer
          ).carouselAltTexts;

          allGalleries.forEach((gallery) => {
            if (Number(gallery.id.charAt(0)) === selectedStep) {
              return;
            }
            gallery.remove();
          });

          if (galleryElementInThisStep) {
            galleryElementInThisStep.remove();
          }

          setTimeout(() => {
            visualGallery.appendChild(
              galleryInstance.init(carouselData, carouselAltTexts)
            );
          }, 100);
        } else {
          if (visualGallery.querySelector(".gallery-container")) {
            visualGallery
              .querySelector(".gallery-container")
              .classList.add("visual-fadeout");
          }
          const image = document.createElement("img");
          image.classList.add("configurator-image");
          if (activeStepData.title === "Replen delivery") {
            image.classList.add("configurator-image--full");
          }
          image.src = activeStepData.unselectedImage;
          image.alt = activeStepData.unselectedImageAltText;

          if (unselectedImage) {
            visualGallery.removeChild(unselectedImage);
            visualGallery.appendChild(image);
          } else {
            visualGallery.appendChild(image);
          }
        }
      }, 300);
    }
  }
  if (configuratorData["0"]) {
    updateHeaderPrice();
  }
};

const renderMobileVisual = (step) => {
  const mobileVisualWrapper = document.createElement("div");
  mobileVisualWrapper.classList.add(
    "configurator-step-visual",
    `configurator-step-visual--${step.order - 1}`
  );
  const mobileVisualContent = document.createElement("div");
  mobileVisualContent.classList.add("configurator-step-visual-content");
  if (step.visual === "numbers") {
    setTimeout(() => {
      let number = midPlan;
      mobileVisualContent.appendChild(animatedNumber.init(number));
      animatedNumber.animate(number);
      drawNumbersByMonthlyPlans();
    }, 300);
  } else if (step.visual === "gallery") {
    const image = document.createElement("img");
    image.classList.add("configurator-image");
    image.src = step.unselectedImage;
    image.alt = step.unselectedImageAltText;
    mobileVisualContent.appendChild(image);
  }

  mobileVisualWrapper.appendChild(mobileVisualContent);
  return mobileVisualWrapper;
};

document.addEventListener("visibilitychange", function () {
  const hasSelectedNumber = Object.values(configuratorData).length > 0;
  if (!hasSelectedNumber) {
    if (document.hidden) {
      if (numbersSwitchInterval) {
        clearInterval(numbersSwitchInterval);
      }
    } else {
      drawNumbersByMonthlyPlans();
    }
  }
});

const renderDragToChoose = (stepElement) => {
  const dragElement = document.querySelector(".configurator-mobile-drag");

  if (dragElement) {
    stepElement.appendChild(dragElement);
    const wrapperElement = document.createElement("div");
    wrapperElement.classList.add("configurator-drag-to-choose-bottom");
    const recommendationMessageElement = document.createElement("p");
    recommendationMessageElement.innerHTML =
      defaultRecommendationChoiceMessage || "";
    recommendationMessageElement.classList.add(
      "typography",
      "label-bold",
      "recommendation-message-mobile"
    );
    const optionInData = FINAL_CONFIGURATOR_DATA.steps[0].options.find(
      (option) => option.snippet === "button"
    );
    const getHelpDecidingButton = document.createElement("button");
    const buttonText = document.createTextNode(optionInData.title);
    const buttonTextElement = document.createElement("span");
    buttonTextElement.appendChild(buttonText);
    buttonTextElement.classList.add(
      "typography",
      "label",
      "choice-button__title"
    );
    getHelpDecidingButton.classList.add("get-help-button-wrapper");
    const iconWrapper = document.createElement("div");
    iconWrapper.innerHTML = optionInData.icon || "";
    iconWrapper.classList.add("choice-button__icon-wrapper");
    getHelpDecidingButton.appendChild(iconWrapper);
    getHelpDecidingButton.appendChild(buttonTextElement);

    const noPlanMessageElement = document.createElement("p");
    const noPlanMessageText = FINAL_CONFIGURATOR_DATA.steps[0].options.find(
      (option) => option.snippet === "checkbox"
    ).description;
    noPlanMessageElement.innerHTML = noPlanMessageText || "";
    noPlanMessageElement.classList.add(
      "typography",
      "label-bold",
      "configurator-checkbox-message"
    );

    getHelpDecidingButton.addEventListener("click", (event) => {
      shouldOpenQuiz = true;
      renderDesktopVisual(0, false, true);
    });

    wrapperElement.appendChild(noPlanMessageElement);
    wrapperElement.appendChild(recommendationMessageElement);
    wrapperElement.appendChild(getHelpDecidingButton);

    stepElement.appendChild(wrapperElement);
  }
};

const configuratorDragChooseCallback = (value) => {
  if (window.innerWidth > 900) return;
  if (numbersSwitchInterval) {
    clearInterval(numbersSwitchInterval);
  }

  // We are matching drag-to-choose.liquid variables here
  const num =
    value === dragToChooseData.noPlan
      ? 0
      : Number(value.replace("Every ", "")[0]);
  const explainerMessage = document.querySelector(
    ".configurator-checkbox-message"
  );

  if (previousDragToChooseValue !== num) {
    animatedNumber.animate(num);
    configuratorData = {
      ...configuratorData,
      0: value,
    };

    handleTableSection(
      FINAL_CONFIGURATOR_DATA.steps[1].options,
      document.querySelector(".configurator-step--1")
    );
    handleNextSectionButtonBehavior();

    const nextStep = document.querySelector(".configurator-step--1");
    if (nextStep) {
      const buttonChildren = Array.from(
        nextStep.getElementsByTagName("button")
      );
      buttonChildren.forEach((button) => {
        button.removeAttribute("disabled");
      });
      nextStep.classList.add("configurator-step--available");
    }

    const section = document.getElementsByClassName("configurator-step--1")[0];
    const sectionTitle = section.getElementsByClassName(
      "configurator-step-title"
    )[0];
    const sectionDescription = section.getElementsByClassName(
      "configurator-step-description"
    )[0];
    const sectionSubtitle = section.getElementsByClassName(
      "replen-delivery-description"
    )[0];

    if (num === 0) {
      explainerMessage.classList.add("configurator-checkbox-message--visible");

      sectionTitle.innerHTML = `2. ${
        FINAL_CONFIGURATOR_DATA.steps[1].noPlanTitle || ""
      }`;
      section.classList.add("noPlan--selected");
      sectionDescription.innerHTML = `${
        FINAL_CONFIGURATOR_DATA.steps[1].noPlanDescription || ""
      }`;
      sectionSubtitle.innerHTML = `${
        FINAL_CONFIGURATOR_DATA.steps[1].noPlanSubtitle || ""
      }`;
    } else {
      explainerMessage.classList.remove(
        "configurator-checkbox-message--visible"
      );
      sectionTitle.innerHTML = `2. ${
        FINAL_CONFIGURATOR_DATA.steps[1].title || ""
      }`;
      section.classList.remove("noPlan--selected");
      sectionDescription.innerHTML = `${
        FINAL_CONFIGURATOR_DATA.steps[1].description || ""
      }`;
      sectionSubtitle.innerHTML = `${
        FINAL_CONFIGURATOR_DATA.steps[1].texts || ""
      }`;
    }
  }

  previousDragToChooseValue = num;
};

const handleTableSection = (options, stepElement) => {
  const selectedOptionInStepOne = configuratorData[0];
  const MAPPED_SECTIONS = {
    undefined: options.filter((element) => element.plan === "default"),
    [CONFIGURATOR_DATA.steps[0].options[0].title]: options.filter(
      (element) => element.plan === "high"
    ),
    [CONFIGURATOR_DATA.steps[0].options[1].title]: options.filter(
      (element) => element.plan === "mid"
    ),
    [CONFIGURATOR_DATA.steps[0].options[2].title]: options.filter(
      (element) => element.plan === "low"
    ),
    "No plan": options.filter((element) => element.plan === "zero"),
    "No plan. Buy it once.": options.filter(
      (element) => element.plan === "zero"
    ),
  };
  const wrapper =
    document.querySelector(".configurator-table-items") ||
    document.createElement("div");
  wrapper.classList.add("configurator-table-items");
  wrapper.textContent = "";
  let activeSection;

  if (selectedOptionInStepOne && !selectedOptionInStepOne.includes("s")) {
    activeSection = MAPPED_SECTIONS[
      `${selectedOptionInStepOne.replace("Every ", "")}`
    ]
      ? MAPPED_SECTIONS[`${selectedOptionInStepOne.replace("Every ", "")}`]
      : options.default;
  } else {
    if (!selectedOptionInStepOne) {
      activeSection = MAPPED_SECTIONS[selectedOptionInStepOne]
        ? MAPPED_SECTIONS[selectedOptionInStepOne]
        : options.default;
    } else {
      activeSection = MAPPED_SECTIONS[
        selectedOptionInStepOne.includes("month")
          ? selectedOptionInStepOne.replace("Every ", "")
          : selectedOptionInStepOne
      ]
        ? MAPPED_SECTIONS[
            selectedOptionInStepOne.includes("month")
              ? selectedOptionInStepOne.replace("Every ", "")
              : selectedOptionInStepOne
          ]
        : options.default;
    }
  }

  activeSection?.forEach((section) => {
    const element = document.createElement("div");
    element.classList.add("configurator-table-item");
    const optionTitle = document.createElement("span");
    optionTitle.classList.add("typography", "label-bold");
    optionTitle.innerHTML = section.title || "";
    const optionValue = document.createElement("span");
    optionValue.classList.add("typography", "label-bold");
    optionValue.innerHTML = section.selected || "";
    element.appendChild(optionTitle);
    element.appendChild(optionValue);

    wrapper.appendChild(element);
  });

  stepElement.insertBefore(
    wrapper,
    stepElement.querySelector(".replen-delivery-bottom-wrapper")
  );
};

const renderButtons = (options, stepIndex, stepElement, step) => {
  // render table
  if (options.some((element) => element.plan === "default")) {
    handleTableSection(options, stepElement);
  } else {
    options.forEach((option) => {
      if (option.snippet !== "checkbox") {
        const optionButton = document.createElement("button");

        if (stepIndex != 0 && stepIndex != 1) {
          step.questionVariantType &&
            optionButton.setAttribute(
              "variant-type",
              `${step.questionVariantType}`
            );
          option.variantOption &&
            optionButton.setAttribute(
              "variant-option",
              `${option.variantOption}`
            );
        }

        optionButton.addEventListener("click", (event) => {
          const firstSection = document.getElementsByClassName(
            "configurator-step--0"
          )[0];
          const checkboxElement = firstSection.getElementsByTagName("input")[0];
          const checked = checkboxElement.checked;
          if (checked && stepIndex == 0) {
            checkboxElement.click();
          }

          handleClick(event, option, stepIndex, true);
        });
        optionButton.classList.add("choice-button-wrapper");
        if (stepIndex !== 0) {
          optionButton.setAttribute("disabled", true);
        }

        //Create color circle
        if (option.color) {
          const optionColor = document.createElement("div");
          optionColor.classList.add(
            "typography",
            "label",
            "choice-button__color"
          );
          optionColor.style.backgroundColor = `${option.color}`;
          optionColor.style.border = `1px solid ${option.border}`;
          optionButton.appendChild(optionColor);
        }
        //Create icon element
        if (option.icon && option.icon.includes("svg")) {
          const iconWrapper = document.createElement("div");
          iconWrapper.innerHTML = option.icon || "";
          iconWrapper.classList.add("choice-button__icon-wrapper");
          optionButton.appendChild(iconWrapper);
        }
        //Create wrapper for title and description
        const buttonInfoWrapper = document.createElement("div");
        optionButton.appendChild(buttonInfoWrapper);
        buttonInfoWrapper.classList.add("choice-button-info-wrapper");

        //Create button title
        const buttonTitle = document.createTextNode(option.title);
        const optionTitle = document.createElement("p");
        optionTitle.classList.add(
          "typography",
          "label",
          "choice-button__title"
        );
        optionTitle.appendChild(buttonTitle);
        buttonInfoWrapper.appendChild(optionTitle);

        //Create button description
        if (option.description) {
          const buttonDescription = document.createTextNode(option.description);
          const optionDescription = document.createElement("p");
          optionDescription.classList.add(
            "typography",
            "label",
            "choice-button__description"
          );
          optionDescription.appendChild(buttonDescription);
          buttonInfoWrapper.appendChild(optionDescription);
        }
        //Create button badge
        if (option.badge) {
          const buttonBadge = document.createTextNode(option.badge);
          const optionBadge = document.createElement("div");
          optionBadge.classList.add(
            "typography",
            "caption",
            "choice-button__badge"
          );
          optionBadge.appendChild(buttonBadge);
          optionButton.appendChild(optionBadge);
        }
        //Create button price
        if (option.price) {
          const buttonPrice = document.createTextNode(option.price);
          const optionPrice = document.createElement("div");
          optionPrice.classList.add(
            "typography",
            "label",
            "choice-button__price"
          );
          optionPrice.appendChild(buttonPrice);
          optionButton.appendChild(optionPrice);
        }
        if (option.snippet === "button") {
          optionButton.classList.remove("choice-button-wrapper");
          optionButton.classList.add("get-help-button-wrapper");
        }

        stepElement.appendChild(optionButton);
      } else {
        if (option.snippet === "checkbox") {
          const checkboxWrapper = document.createElement("div");
          checkboxWrapper.classList.add("configurator-checkbox-wrapper");
          const checkbox = document.createElement("input");
          checkbox.id = "configurator-checkbox";
          checkbox.type = "checkbox";

          const checkboxLabel = document.createElement("label");
          const labelText = document.createTextNode(option.title);
          checkboxLabel.appendChild(labelText);
          checkboxLabel.classList.add("typography", "label-bold");
          checkboxLabel.setAttribute("for", "configurator-checkbox");

          checkboxWrapper.appendChild(checkbox);
          checkboxWrapper.appendChild(checkboxLabel);

          stepElement.appendChild(checkboxWrapper);

          const checkboxSelectedMessage = document.createElement("p");
          const messageText = document.createTextNode(option.description || "");
          checkboxSelectedMessage.classList.add(
            "typography",
            "label-bold",
            "configurator-checkbox-message"
          );
          checkboxSelectedMessage.appendChild(messageText);

          checkbox.addEventListener("change", (event) =>
            handleCheckboxChange(event, checkboxSelectedMessage)
          );

          stepElement.appendChild(checkboxSelectedMessage);
        }
      }
    });
  }
};

const handleCheckboxChange = (event, textElement) => {
  const firstSection = document.getElementsByClassName(
    "configurator-step--0"
  )[0];
  const checkboxElement = firstSection.getElementsByTagName("input")[0];
  const checked = checkboxElement.checked;
  const nextStep = document.querySelector(".configurator-step--1");

  const selectedButton = document.querySelector(
    ".choice-button-wrapper--selected"
  );
  const section = document.getElementsByClassName("configurator-step--1")[0];
  const sectionTitle = section.getElementsByClassName(
    "configurator-step-title"
  )[0];
  const sectionDescription = section.getElementsByClassName(
    "configurator-step-description"
  )[0];
  const sectionSubtitle = section.getElementsByClassName(
    "replen-delivery-description"
  )[0];

  if (checked) {
    textElement.classList.add("configurator-checkbox-message--visible");
    sectionTitle.innerHTML = `2. ${
      FINAL_CONFIGURATOR_DATA.steps[1].noPlanTitle || ""
    }`;

    section.classList.add("noPlan--selected");
    sectionDescription.innerHTML = `${
      FINAL_CONFIGURATOR_DATA.steps[1].noPlanDescription || ""
    }`;
    sectionSubtitle.innerHTML = `${
      FINAL_CONFIGURATOR_DATA.steps[1].noPlanSubtitle || ""
    }`;

    if (selectedButton) {
      selectedButton.classList.remove("choice-button-wrapper--selected");
    }
    // Animate to "0"
    clearInterval(numbersSwitchInterval);
    animatedNumber.animate(0);
  } else {
    textElement.classList.remove("configurator-checkbox-message--visible");
    sectionTitle.innerHTML = `2. ${
      FINAL_CONFIGURATOR_DATA.steps[1].title || ""
    }`;

    sectionDescription.innerHTML = `${
      FINAL_CONFIGURATOR_DATA.steps[1].description || ""
    }`;
    sectionSubtitle.innerHTML = `${
      FINAL_CONFIGURATOR_DATA.steps[1].texts || ""
    }`;

    section.classList.remove("noPlan--selected");
    // Set random number creation
    drawNumbersByMonthlyPlans();
  }
  configuratorData[1] = "";
  toggleControlsDisabledState();

  configuratorData = {
    ...configuratorData,
    0: checked ? "No plan" : undefined,
  };

  updateHeaderPrice();
  handleTableSection(
    FINAL_CONFIGURATOR_DATA.steps[1].options,
    document.querySelector(".configurator-step--1")
  );
  handleNextSectionButtonBehavior();

  document
    .querySelector(".configurator-step--1")
    .classList.add("configurator-step--available");

  if (
    nextStep &&
    !nextStep.classList.contains(".configurator-step--available")
  ) {
    nextStep.classList.add("configurator-step--available");
    const buttonChildren = Array.from(nextStep.getElementsByTagName("button"));
    buttonChildren.forEach((button) => {
      button.removeAttribute("disabled");
    });
  }
};

const handleConfirmClick = () => {
  configuratorData = {
    ...configuratorData,
    1: "confirmed",
  };
  toggleControlsDisabledState();
  handleNextSectionButtonBehavior();

  const stepTwo = document.querySelector(".configurator-step--2");
  if (stepTwo) {
    stepTwo.classList.add("configurator-step--available");
    const buttonChildren = Array.from(stepTwo.getElementsByTagName("button"));
    buttonChildren.forEach((button) => {
      button.removeAttribute("disabled");
    });
  }
};

const renderForm = () => {
  const header = document.createElement("h1");
  header.classList.add(
    "typography",
    "headline-l",
    "configurator-product-title"
  );
  const headerText = document.createTextNode(
    FINAL_CONFIGURATOR_DATA.headingText
  );
  header.appendChild(headerText);

  selection.appendChild(header);

  FINAL_CONFIGURATOR_DATA.steps.forEach((step, stepIndex) => {
    const showDragToChoose =
      step.visual === "numbers" &&
      breakpointVariant === BREAKPOINT_VARIANTS.MOBILE;
    const stepElement = document.createElement("div");
    stepElement.classList.add(
      "configurator-step",
      `configurator-step--${stepIndex}`
    );

    if (step.visual === "gallery") {
      const gallery = new Gallery(stepIndex);
      galleries.push(gallery);
    }

    if (stepIndex === 0) {
      stepElement.classList.add("configurator-step--available");
    }

    const stepTitle = document.createElement("h2");
    const titleText = document.createTextNode(`${step.order}. ${step.title}`);
    stepTitle.classList.add(
      "typography",
      "headline-s",
      "configurator-step-title"
    );
    stepTitle.appendChild(titleText);

    const stepDescription = document.createElement("p");
    const descriptionText = document.createTextNode(step.description);
    stepDescription.classList.add(
      "typography",
      "body",
      "configurator-step-description"
    );
    stepDescription.appendChild(descriptionText);

    stepElement.appendChild(stepTitle);
    stepElement.appendChild(stepDescription);

    if (!showDragToChoose) {
      renderButtons(step.options, stepIndex, stepElement, step);

      if (step.title === "Replen delivery" || step.title === "Delivery Schedule") {
        const bottomWrapper = document.createElement("div");
        bottomWrapper.classList.add("replen-delivery-bottom-wrapper");

        const label = document.createElement("p");
        label.innerHTML = step.texts || "";
        label.classList.add(
          "typography",
          "body",
          "replen-delivery-description"
        );
        bottomWrapper.appendChild(label);

        const button = document.createElement("button");
        button.addEventListener("click", handleConfirmClick);
        button.classList.add(
          "choice-button-wrapper",
          "choice-button-wrapper--confirm"
        );
        button.setAttribute("disabled", true);

        const buttonTextElement = document.createElement("span");
        buttonTextElement.innerHTML = "Confirm";
        buttonTextElement.classList.add("typography", "label");
        button.appendChild(buttonTextElement);
        bottomWrapper.appendChild(button);
        stepElement.appendChild(bottomWrapper);
      }
    }

    if (breakpointVariant === BREAKPOINT_VARIANTS.MOBILE) {
      stepElement.appendChild(renderMobileVisual(step));
    }

    if (showDragToChoose) {
      renderDragToChoose(stepElement);
    }

    selection.appendChild(stepElement);
  });

  const formControlsElement = document.createElement("div");
  formControlsElement.classList.add("configurator-controls");

  const addToBagButton = document.createElement("button");
  const addToBagTitle = document.createTextNode("Add to bag");

  addToBagButton.addEventListener("click", () => {
    const configuratorPage = document.getElementById("configurator-page");
    const accessoriesPage = document.getElementById("accessories-page");
    const hasNumber = /\d/;

    finalChoiceForAccessoriesPage = hasNumber.test(configuratorData["0"])
      ? configuratorData["0"]
      : "no";

    const arraysMatch = function (arr1, arr2) {
      // Check if the arrays are the same length
      if (arr1.length !== arr2.length) return false;

      // Check if all items exist and are in the same order
      for (var i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) return false;
      }
      // Otherwise, return true
      return true;
    };

    const chosenVariant =
      productInfo.variants.length > 1
        ? productInfo.variants.find((variant) =>
            arraysMatch(variant.options, variantOptionsArray)
          )
        : productInfo.variants[0];
    const variantId =
      productInfo.variants.length > 1
        ? chosenVariant.id
        : productInfo.variants[0].id;

    // If subscription
    if (finalChoiceForAccessoriesPage !== "no" && chosenVariant) {
      const formattedPlan = parseInt(
        finalChoiceForAccessoriesPage.replace(/[^0-9]/g, "")
      );

      // Find replen variant
      if (replenInfo) {
        const replenVariant = replenInfo.variants.find(
          (variant) => variant.title === chosenVariant.title
        );
        // Get replen info from recharge
        if (replenVariant) {
          window.ReChargeWidget.api
            .fetchProduct(replenInfo.id)
            .then((rechargeResponse) => {
              const rechargeReplenId = rechargeResponse.variants.find(
                (variant) => variant.id === replenVariant.id
              ).id;
              const rechargePlanId =
                rechargeResponse.selling_plan_groups[0].selling_plans.find(
                  (planId) => planId.order_interval_frequency === formattedPlan
                ).selling_plan_id;

              liquidAjaxCart.cartRequestAdd({
                items: [
                  {
                    id: variantId ? variantId : productInfo.id,
                    quantity: 1,
                  },
                  {
                    id: rechargeReplenId,
                    selling_plan: rechargePlanId,
                    quantity: 1,
                  },
                ],
              });
            });
        }
      } else {
        if (productInfo.tags.includes("replen") && variantId) {
          const replenVariant = productInfo.variants.find(
            (variant) => variant.title === chosenVariant.title
          );
          if (replenVariant) {
            window.ReChargeWidget.api
              .fetchProduct(productInfo.id)
              .then((rechargeResponse) => {
                const rechargeReplenId = rechargeResponse.variants.find(
                  (variant) => variant.id === replenVariant.id
                ).id;
                const rechargePlanId =
                  rechargeResponse.selling_plan_groups[0].selling_plans.find(
                    (planId) =>
                      planId.order_interval_frequency === formattedPlan
                  ).selling_plan_id;

                liquidAjaxCart.cartRequestAdd({
                  items: [
                    {
                      id: variantId ? variantId : productInfo.id,
                      quantity: productInfo.tags.includes("replen") ? 0 : 1,
                    },
                    {
                      id: rechargeReplenId,
                      selling_plan: rechargePlanId,
                      quantity: 1,
                    },
                  ],
                });
              });
          }
        } else {
          // simple subscription product (ex: The Shower Liner)
          // get ReCharge Plan Info from Product
          let rechargePlanId;
          productInfo.selling_plan_groups[0].selling_plans.forEach(plan => {
            if (plan.name.includes(formattedPlan)) {
              rechargePlanId = plan.id;
            }
          });
          // add it to cart
          liquidAjaxCart.cartRequestAdd({
            items: [
              {
                id: chosenVariant.id,
                selling_plan: rechargePlanId,
                quantity: 1,
              },
            ],
          });

        }
      }
    }

    if (finalChoiceForAccessoriesPage === "no") {
      liquidAjaxCart.cartRequestAdd({
        items: [
          {
            id: variantId ? variantId : productInfo.id,
            quantity: 1,
          },
        ],
      });
    }

    const querySelectorAll = Array.from(
      document.querySelectorAll(".accessories-header-description")
    );

    querySelectorAll.forEach((element) => {
      if (element.classList.contains("sticky-header")) {
        if (window.innerWidth > 600) {
          element.innerHTML = `${accessoriesHeaderProductTitle} with ${finalChoiceForAccessoriesPage} Replen plan`;
        } else {
          element.innerHTML = `${accessoriesHeaderProductTitle}`;
        }
      } else {
        element.innerHTML = `with ${finalChoiceForAccessoriesPage} Replen plan`;
      }
    });

    accessoriesPageVisible = true;
    configuratorPage.style.opacity = 0;
    setTimeout(() => {
      document.documentElement.scrollTo({
        top: 0,
        left: 0,
      });

      configuratorPage.style.display = "none";
      accessoriesPage.style.display = "block";
    }, 2000);
  });

  addToBagButton.classList.add("typography", "label", "configurator-add");
  addToBagButton.setAttribute("data-add-to-cart", "");
  addToBagButton.appendChild(addToBagTitle);
  formControlsElement.appendChild(addToBagButton);

  addToBagButton.setAttribute("data-disabled", true);
  addToBagButton.setAttribute("disabled", true);

  selection.appendChild(formControlsElement);
};

const handleControlsArrowClick = () => {
  if (nextUncompletedSection) {
    window.scrollTo({
      top: nextUncompletedSection.offsetTop - PADDING_OFFSET,
      left: 0,
      behavior: "smooth",
    });
  }
};

const renderControls = () => {
  const button = document.createElement("button");
  button.classList.add("configurator-control-button");
  configurator.appendChild(button);
  button.addEventListener("click", handleControlsArrowClick);
};

window.addEventListener("DOMContentLoaded", () => {
  renderForm();
  renderControls();

  const accordionClass = customElements.get("accordion-component");
  if (accordionClass) {
    accordion = new accordionClass(
      QUIZ_DATA,
      quizState ? quizState : undefined
    );
  }

  const allSteps = Array.from(document.querySelectorAll(".configurator-step"));
  allSteps.forEach((step) => {
    offsetTops.push(step.offsetTop);
  });
});

window.addEventListener("resize", () => {
  setBreakpointVariant(window.innerWidth);
});

// /pages/$product-configurator -> products/$product.js
const productUrl =
  window.Shopify.routes.root.replace("/", "") +
  location.pathname
    .replace("/pages", "/products")
    .replace("-configurator", "") +
  ".js";
fetch(productUrl)
  .then((response) => response.json())
  .then((productData) => {
    productInfo = productData;

    // if parent product, find replen data
    if (productData.title === productData.type) {
      const replenUrl =
        window.Shopify.routes.root.replace("/", "") +
        location.pathname
          .replace("/pages", "/products")
          .replace("-configurator", "")
          .replace("system", "replen") +
        "-plan.js";
      fetch(replenUrl)
        .then((response) => response.json())
        .then((replenData) => {
          replenInfo = replenData;
        });
    }
  });
